import { memo } from 'react';

import { useDroppable } from '@dnd-kit/core';

import {
  DayPart,
  PlanningEntityIdentifier,
  PlanningEntityType,
  TransportationMode
} from 'generated';

import { formatSecondsToHoursMinutes } from 'utils/date';

import { Box, styled } from '@mui/material';

import DropIndicator from '../DropIndicator/DropIndicator';
import { panelThemeColors, PanelTheme } from '../ActivityPanel/constants';
import { DARK } from 'constants/colors';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import { faBicycle, faCar } from '@fortawesome/pro-light-svg-icons';

const StyledTravelTime = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 0;
  margin: -20px 0;
  width: 100%;
  min-height: 70px;
`;

// const Border = styled(Box)<{$borderColor?: string}>`
//   border-top: 1px solid ${props => props.$borderColor || 'transparent'};
//   width: 100%;
// `;

const TextContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 2px 8px;
  white-space: nowrap;
  z-index: 10;
  font-size: 12px;
`;

interface TravelTimeProps {
  id: string;
  dayPart: DayPart;
  scheduleStart: string;
  start: string;
  durationInSeconds: number;
  droppable: boolean | undefined;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
  transportationMode?: TransportationMode;
}

function TravelTime({
  id,
  dayPart = 'MORNING',
  droppable,
  scheduleStart,
  start,
  durationInSeconds,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier,
  transportationMode = 'CAR'
}: TravelTimeProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled: !droppable,
    data: {
      scheduleStart,
      start,
      planningEntityId,
      planningEntityType,
      planningEntityIdentifier
    }
  });

  const { textColor } = panelThemeColors[dayPart as PanelTheme];
  const isCarRoute = transportationMode === 'CAR';

  return (
    <StyledTravelTime
      component="li"
      ref={setNodeRef}
      className="traveltime-container"
      my={1}
    >
      {isOver ? (
        <DropIndicator />
      ) : (
        <TextContainer color={textColor}>
          <FontAwesomeSvgIcon
            icon={isCarRoute ? faCar : faBicycle}
            sx={{
              fontSize: isCarRoute ? '12px' : '16px',
              color: DARK,
              marginRight: '8px'
            }}
          />
          {`${formatSecondsToHoursMinutes(durationInSeconds)} reistijd`}
        </TextContainer>
      )}
    </StyledTravelTime>
  );
}

export default memo(TravelTime);
